import { monospaceFont } from '@phishtool/ui';
import { createGlobalStyle } from 'styled-components';
const GlobalStyle = createGlobalStyle `
  body {
    overscroll-behavior-y: none;
    overflow: hidden;
  }

  #app {
    height: calc(var(--vh, 1vh) * 100);
    display: flex;
    flex-direction: column;
  }

  body.redoc {
    overflow: auto;

    #app {
      height: auto;
      display: block;
    }

    .redoc-content {
      .react-tabs__tab-list {
        display: none;
      }
    
      h1 {
        font-size: 23px !important;
      }
    
      h2 {
        font-size: 18px !important;
      }
    
      h1, h2, h3, h4, h5 {
        margin-bottom: 0 !important;
        font-weight: 700 !important;
      }
    
      h3 {
        color: ${(props) => props.theme.colors.oxfordBlue} !important;
        font-size: 16px !important;
        margin-bottom: 15px !important;
      }
    
      .menu-content {
        &.is-open {
          display: flex !important;
        }
        
        * {
          font-size: 14px !important;
        }
    
        .hook,
        .post,
        .put,
        .get,
        .delete {
          font-size: 7px !important;
        }
      }
    
      .react-tabs__tab-panel {
        > div {
          > div:first-child {
            background-color: ${(props) => props.theme.colors.spaceCadet} !important;
            > span {
              display: none;
            }
          }
        }
      }
    
      .scrollbar-container > div {
        display: none;
      }
    
      code {
        font-family: ${monospaceFont}
      }

      [data-section-id="tag/analyses"] {
        border-top: 1px solid rgba(0,0,0,0.2);
        margin: 35px 0 0;
      }
    }
  }
`;
export default GlobalStyle;
